export const environment = {
  production: true,
  apiUrl: 'https://api.livwell.asia/livwell/api',
  API_KEY: 'Wyf;9UKC1d?$CRRG&=}4?+/vS>)%Lg;r',
  API_KEY_2: '1234',
  FINGER_PRINT: 'Basic b25lTGlmZTpPbkVsSWZFQCMyNSY= ',
  CLEVERTAP_ACCOUNT_ID: '4R6-6R8-867Z',
  CLEVERTAP_REGION: 'sg1', // Singapore region
  clevertapLogLevel: 3, // 0=disable, 1=errors, 2=errors+info, 3=all logs
lokalConfig: {
    appId: '22f31d98-46ed-4da6-a1d0-7150d9ffd469',
    apiKey: 'lk_uu04SC0pt6lm',
    apiUrl: 'https://lokal-api.livwell.asia/api/v3/sdk/export'
  }
};
